import React from "react"
import { Box, Tooltip, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"
import { DS_REPRICING_STEPS } from "Pages/DsRepricing/Page/Drawer/steps"

// Horizontal stepper across the top of the drawer: it names the four stages and doubles as
// navigation. Steps stay clickable in both directions — blocking backwards movement on a config
// form only traps people who want to re-check what they typed.
function StepBubble({ index, state, hasError }) {
	const isDone = state === 'done'
	const isActive = state === 'active'

	const bg = isDone ? dsColorNew.successBar : isActive ? dsColorNew.appBlue : dsColorNew.white
	const borderColor = hasError
		? dsColorNew.warningBar
		: isDone ? dsColorNew.successBar : isActive ? dsColorNew.appBlue : dsColorNew.grayBorder

	return (
		<Box
			sx={{
				width: 26, height: 26, borderRadius: '50%', flex: '0 0 auto',
				display: 'flex', alignItems: 'center', justifyContent: 'center',
				fontSize: 12, fontWeight: 600, transition: '.15s',
				border: '1.5px solid', borderColor, bgcolor: bg,
				color: isDone || isActive ? dsColorNew.white : dsColorNew.textSubtle,
			}}
		>
			{isDone ? <IconSeeker icon="check" sx={{ fontSize: 12 }}/> : index}
		</Box>
	)
}

export default function DsRepricingStepper({ current, invalidSteps, onSelect }) {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', px: 1, pt: 2, pb: 0.5, flex: '0 0 auto' }}>
			{DS_REPRICING_STEPS.map(({ step, kicker, label, sub, optional }, i) => {
				const isActive = step === current
				const hasError = invalidSteps.includes(step)
				// "Done" means visited and valid, not merely behind the cursor: a step left with errors
				// has to keep looking unfinished or the stepper would lie about the state of the form.
				const state = isActive ? 'active' : step < current && !hasError ? 'done' : 'idle'

				return (
					<React.Fragment key={step}>
						{i > 0 && (
							<Box sx={{ flex: 1, height: '1.5px', bgcolor: dsColorNew.grayBorder, mx: 1.5, minWidth: 16 }}/>
						)}
						<Tooltip title={optional ? `${sub} · optional` : sub} placement="bottom">
							<Box
								onClick={() => onSelect(step)}
								sx={{ display: 'flex', alignItems: 'center', gap: 1.125, cursor: 'pointer' }}
							>
								<StepBubble index={step} state={state} hasError={hasError}/>
								<Box sx={{ display: { xs: 'none', sm: 'flex' }, flexDirection: 'column',
								           lineHeight: 1.15 }}>
									{kicker && (
										<Typography
											sx={{
												fontSize: 11, whiteSpace: 'nowrap',
												fontWeight: 700, letterSpacing: '0.14em',
												color: isActive ? dsColorNew.appBlue : dsColorNew.textSubtle,
												textTransform: 'uppercase',
												fontStyle: optional ? 'italic' : 'normal',
												opacity: optional && !isActive ? 0.7 : 1,
											}}
										>
											{kicker}{optional ? ' · opt' : ''}
										</Typography>
									)}
									<Typography
										sx={{
											fontSize: 12, whiteSpace: 'nowrap',
											fontWeight: isActive ? 600 : 500,
											color: isActive ? dsColorNew.textTitle : dsColorNew.textMuted,
											fontStyle: optional && !isActive ? 'italic' : 'normal',
										}}
									>
										{label}
									</Typography>
								</Box>
							</Box>
						</Tooltip>
					</React.Fragment>
				)
			})}
		</Box>
	)
}